import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import Parameters from '../../Views/ParametersWrapper/form/FormParameters'
import {TabCentralModel} from '../../../../../models'
import ButtonClose from '../../../../../components/UI/Button/IconButton'
import {useCentral} from '../../../../../hooks/useCentral'
import {TableCostsWrapper} from '../../Views/ParametersWrapper/table/TableCosts'
const ParameterTab = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()

  const handleBack = () => {
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      editOnBottomPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel d-flex flex-column h-100'>
      {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}

      <Tabs className={'sdx_sub_react_tab_panel flex-grow-1'}>
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
          {isAllowed('COSTO/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Tabla de Costos</Tab>
          )}
        </TabList>
        <TabPanel>
          <Parameters />
        </TabPanel>
        <TabPanel>
          <TableCostsWrapper />
        </TabPanel>
      </Tabs>
    </div>
  )
}

export default ParameterTab
